"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = NotFoundPage;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const ErrorPage_1 = require("./ErrorPage");
function NotFoundPage({ t, tReady }) {
    return (react_1.default.createElement(ErrorPage_1.ErrorPage, { headerText: t('notFoundHeader'), buttonText: t('notFoundButton'), t: t, tReady: tReady }));
}
exports.default = (0, react_i18next_1.withTranslation)('ErrorPage')(NotFoundPage);
